import { createContext, Dispatch, ReactElement, ReactNode, SetStateAction, useContext, useState } from 'react';

interface SidebarState {
  width: number;
}

const defaultSidebarState: SidebarState = {
  width: 0,
};

const SidebarContext = createContext<[SidebarState, Dispatch<SetStateAction<SidebarState>>]>([
  defaultSidebarState,
  () => undefined,
]);

interface SidebarProviderProps {
  children?: ReactNode;
}

export function SidebarProvider({ children }: Readonly<SidebarProviderProps>): ReactElement<SidebarProviderProps> {
  const value = useState<SidebarState>(defaultSidebarState);
  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
}

export function useSidebarContext(): [SidebarState, Dispatch<SetStateAction<SidebarState>>] {
  return useContext(SidebarContext);
}
